/**
 * Masked for replay means never in analytics (tv45.100).
 *
 * `.ph-mask` and `.ph-block` are session-replay settings: they reach only
 * the recorder. posthog-js copies the clicked element's text, classes and
 * attributes into `$elements_chain` on every element event it builds —
 * `$autocapture`, `$rageclick`, `$dead_click`, `$dead_swipe`,
 * `$copy_autocapture` — and the chain lists the target and each ancestor up
 * to `<body>` with its classes. An event whose chain names either class came
 * from inside a masked subtree, so `before_send` in `app.ts` drops it,
 * whatever the event is called.
 *
 * It cannot see a masked span INSIDE a button or link: posthog-js folds that
 * span's text into the button's own `$el_text`, and the chain names only the
 * button and its ancestors. `.ph-no-capture` on the host, or `.ph-sensitive`
 * on the span, is the guard there, and `analyticsLeaks()` in
 * `analytics-privacy.testing.ts` finds a surface that has neither.
 */
export function chainNamesReplayMask(chain: string): boolean {
  return chain.includes('ph-mask') || chain.includes('ph-block');
}
